export default __webpack_public_path__ + "static/sphere-aa4f2204b228c9238a57d6d1694b89c8.png";